import {
  listPublicContentBlocks,
  listPublicPageContents,
} from "./cmsApi";

function parseContent(raw) {
  if (raw == null) return {};
  if (typeof raw === "object") return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

async function hydrateSection(section) {
  const blocks = await listPublicContentBlocks(section.id);
  return {
    id: section.id,
    sectionName: section.sectionName,
    contentType: section.contentType,
    order: section.order ?? 0,
    content: parseContent(section.content),
    blocks: blocks
      .filter((block) => block.isActive !== false)
      .map((block) => ({
        id: block.id,
        blockType: block.blockType,
        order: block.order ?? 0,
        isActive: true,
        content: parseContent(block.content),
      })),
  };
}

export async function loadStoryRoute(pageName = "story-route") {
  const sections = await listPublicPageContents(pageName);
  const activeSections = sections.filter((section) => section.isActive !== false);

  const sectionsWithBlocks = await Promise.all(
    activeSections.map(hydrateSection)
  );

  return sectionsWithBlocks.sort((a, b) => a.order - b.order);
}

export async function loadStoryRouteSection(sectionName, pageName = "story-route") {
  const sections = await listPublicPageContents(pageName);
  const section = sections.find(
    (item) => item.sectionName === sectionName && item.isActive !== false
  );
  return section ? hydrateSection(section) : null;
}
